import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { useState } from "react";
import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import URLS from "@api/constants/urls";

export const useGetAllAlertLogsServices = ({
  page = "1",
  per_page = "15",
  enableQuery,
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);

  const allAlertLogsServices = useQuery({
    queryKey: [...CACHE_KEYS.ALERT_LOGS, page, debouncedQuery, per_page],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.ALERT_LOGS,
        searchParams: {
          page: page,
          per_page: per_page,
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { allAlertLogsServices },
    states: { searchQuery, setSearchQuery },
  };
};
